

import {Component, Vue, Prop} from "vue-property-decorator";

import {MigrateStore} from '@/components/status/MigrateStore';
import {RestoreCommonStep} from '@/components/status/RestoreCommonStep';

import {GetFilingLocations} from '@/components/status/GetFilingLocations'

import { namespace } from "vuex-class";
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component
export default class UnsuccessPage extends Vue {

    @Prop({required: true})
    packageInfo!: any;

    @applicationState.Action
    public checkAllCompleted!: () => void

    disableResumeApplication = true;

    mounted(){
        this.disableResumeApplication = true;
        this.getApplicationEfilingStatus()
    }

    public viewStatus() {
        this.$router.push({ name: "applicant-status" });
    }
    
    public resubmitApplication() {
        if(this.packageInfo.fileNumber)
            this.resumeApplication(this.packageInfo.fileNumber)
    }    

    public async resumeApplication(applicationId) { 

        await GetFilingLocations();
        
        this.$http.get('/app/'+ applicationId + '/')
        .then((response) => {

            const applicationData = response.data   
            const applicationType = (applicationData.type?.length>0)? Vue.filter('typesToFullnames')(applicationData.type.split(',')):[];
           
            const storeMigrationFn = new MigrateStore()           
            const currentApplication = storeMigrationFn.migrate(applicationData, applicationType, Vue.filter('get-current-version')())

            const comStepFn = new RestoreCommonStep()
            comStepFn.restore(currentApplication)
           
            this.checkAllCompleted();
           
            this.$router.push({name: "flapp-surveys" }) 

        }, err => {
            console.log(err)        
        });
    } 
    
    public getApplicationEfilingStatus() {
   
        this.$http.get('/app-list/')
        .then((response) => {
            
            for (const appJson of response.data) {
                const lastFiled = appJson.last_filed
                const id = appJson.id;
                if(this.packageInfo.fileNumber == id && !lastFiled){
                    this.disableResumeApplication = false;
                    break;
                }
            }
                   
        },(err) => {
               console.log(err)    
        });
    }


}
